import React from "react";
import {observer} from "mobx-react-lite";
import {useSitStores} from "../../../../stores";
import {sitFieldLabel} from "../../../sitLabels";

/**
 * Evidence links (e.g. SharePoint) proving an efficiency — surfaced for audit
 * in the list and the financial report.
 */
export const InitiativeEvidenceForm: React.FC = observer(() => {
    const {initiativeInstanceStore: s} = useSitStores();
    const dis = s.disabled;
    const evidence = s.instance.evidence ?? [];

    return (
        <div className="sit-miles">
            {evidence.map((ev, index) => (
                <div key={index} className="sit-evid-row">
                    <input className="sit-evid-label" placeholder="Label" value={ev.label ?? ''} disabled={dis}
                           onChange={e => ev.label = e.target.value}/>
                    <input className="sit-evid-url" type="url" placeholder="https://…" value={ev.url ?? ''} disabled={dis}
                           onChange={e => ev.url = e.target.value}/>
                    <button type="button" className="sit-rm-btn" disabled={dis}
                            onClick={() => s.removeEvidence(index)} aria-label="Remove">✕
                    </button>
                </div>
            ))}
            <button type="button" className="sit-add-line" disabled={dis} onClick={() => s.addEvidence()}>
                + {sitFieldLabel('evidence')}
            </button>
        </div>
    );
});
